module.exports = __webpack_public_path__ + "img/characters.a0cec2b7.png";